import { render, staticRenderFns } from "./InterviewList.vue?vue&type=template&id=0af65968&"
import script from "./InterviewList.vue?vue&type=script&lang=js&"
export * from "./InterviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports